<section *transloco="let t; read: 'dashboard-options-component.dashboard-option-save-export'">
  <div class="section-title">
    <h3>{{ t('save-export') }}</h3>
    <p>
      {{ t('s-e-details') }}
    </p>
  </div>

  <div class="section-field">
    <xi-default-button
      type="button"
      text="{{ t('save-as') }}"
      fill="text"
      iconLeft="save"
      (onClick)="saveAsDashboard.emit()"
      [disabled]="isReadOnly || dashboard.locked"
    ></xi-default-button>

    <xi-default-button
      type="button"
      text="{{ t('export') }}"
      fill="text"
      iconLeft="external_link"
      (onClick)="exportDashboard.emit()"
    ></xi-default-button>
  </div>
</section>
